import { Integration } from '../../shared/interfaces/integration';
import { OperandValue } from '../../shared/utils/filters';
import { RawSubscription } from './Interface';

export const getSortValue = (item: Integration, field: string) => {
  switch (field) {
    case 'pipeline_name':
      return item.name.trim().toLowerCase();
    case 'source':
      return item.source?.name.trim().toLowerCase();
    case 'destination':
      return item.destination?.name.trim().toLowerCase();
    case 'created_by':
      return item.createdBy?.trim().toLowerCase();
    default:
      return item.name.trim().toLowerCase();
  }
};

export const SEARCH_FILTER_KEY = 'term';

export const getFilterKeyMatchValue = (filterKey: string, item: Integration): OperandValue => {
  switch (filterKey) {
    case 'destination_name':
      return item.destination?.name;
    case 'source_name':
      return item.source?.name;
    case 'created_by':
      return item.createById;
    case SEARCH_FILTER_KEY:
      return [item.name, item.source?.name || '', item.destination?.name || ''];
    default:
      return undefined;
  }
};

export const getRawDataForSelectedPipelines = (items: Set<string | number>) => {
  const rawData: RawSubscription[] = [];
  items.forEach(item => {
    rawData.push({ entity_type: 'PIPELINE', entity_id: item });
  });
  return rawData;
};
